import { SplashScreen } from '@capacitor/splash-screen';
import useToast from './useToast';

export function useAppInit() {
    const { openToast } = useToast();

    const initializeApp = async () => {
        try {
            console.log('[AppInit] Starting app initialization...');
            // Show splash screen
            await SplashScreen.show();

            // Initialize location store (handles all loading/validation)
            // This will throw an error if location permission is denied
            // await locationStore.initialize();

            console.log('[AppInit] Initialization complete, hiding splash...');
            // Hide splash screen after successful initialization
            await SplashScreen.hide();
        } catch (error: any) {
            console.error('[AppInit] Initialization error:', error);
            // Hide splash screen
            await SplashScreen.hide();

            // Show error message to user
            // openToast(
            //     'Location access is required to use this app. Please enable location in your device settings.',
            //     'danger',
            //     'top',
            //     0, // Don't auto-dismiss
            // );

            // Re-throw to prevent app from continuing in broken state
            throw error;
        }
    };

    return {
        initializeApp,
    };
}
